// src/lib/lead/actions/loadLeadIntoEditor.ts
import type { Lead } from "@/types/lead";

type RefLike<T> = { current: T };

export type LoadLeadIntoEditorDeps = {
  setCurrentLead: (l: Lead) => void;
  setTranscript: (t: string) => void;
  setIsListening: (v: boolean) => void;
  setMergeSuggestion: (v: any) => void;

  currentLeadRef: RefLike<Lead | null>;
  transcriptRef: RefLike<string>;
  listeningRef: RefLike<boolean>;

  findMergeSuggestionForCurrent: () => any;

  schedule?: (fn: () => void) => void; // default: setTimeout(fn, 0)
};

export function loadLeadIntoEditor(lead: Lead, deps: LoadLeadIntoEditorDeps) {
  deps.setCurrentLead(lead);
  deps.currentLeadRef.current = lead;

  deps.setTranscript(lead.transcript);
  deps.transcriptRef.current = lead.transcript;

  deps.setIsListening(false);
  deps.listeningRef.current = false;

  deps.setMergeSuggestion(null);

  const schedule = deps.schedule ?? ((fn) => setTimeout(fn, 0));
  schedule(() => deps.setMergeSuggestion(deps.findMergeSuggestionForCurrent()));
}